import { TriangleAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

/**
 * Warns that no practitioner is assigned to this client, so the 8857's preparer
 * block will print blank (legacy "no practitioners assigned" red alert). Renders
 * nothing once a practitioner is assigned. Data entry is *not* blocked — advisory
 * only (§9). Links to the client profile where practitioners are managed.
 */
export function NoPractitionerBanner({
  clientId,
  practitioner,
}: {
  clientId: string;
  practitioner?: string;
}) {
  if (practitioner) return null;
  return (
    <Alert variant="destructive">
      <TriangleAlert />
      <AlertTitle>No practitioner assigned</AlertTitle>
      <AlertDescription>
        The preparer block on the generated Form 8857 will be blank until a
        practitioner is assigned to this client.{" "}
        <Link to={`/client/${clientId}/profile`} className="font-medium underline">
          Add a practitioner
        </Link>
        .
      </AlertDescription>
    </Alert>
  );
}
